export const DEFAULT_PROPS = Object.freeze({
	DAIRY_ID: -1,
	DAIRY_NAME: 'No Diary Name Given for MainPage',
	USERNAME: 'none',
	LAST_LOGIN: null,
	SUBDAIRIES: null,
	REPORTS: []
})

export const INITIAL_VALUES = Object.freeze({
	FROM_DATE: '2021-02-01',
	TO_DATE: '2021-02-28'
})

export const DATE_RANGE_TEXT = "Date Range"
export const MOST_RECENT_TEXT = "Most Recent"
export const MONTHLY_TEXT = "Monthly"